<div class="modal-header">
  <div class="modal-header-title">Are you ready to start?</div>
  <cross (click)="cancel()"></cross>
</div>
<div class="modal-body">
  <div class="alert alert-danger">
    <p class="warning">Warning! Once started, you must complete the quiz.</p>
    @if (quiz.TimeLimit === null) {
    <p>
      This quiz can't be exited until you finish. Do not click Start Quiz unless you are certain you can finish in one
      sitting.
    </p>
    } @if (quiz.TimeLimit !== null) {
    <p>
      This timed quiz can't be paused or exited once it starts counting down. Do not click Start Quiz unless you are
      certain you have enough uninterrupted time to finish in one sitting.
    </p>
    }
  </div>
  <p class="name">{{ quiz.Name }}</p>
  <p class="questions-number">{{ quiz.QuestionsNumber | numeral: 'Question' }}</p>
  @if (quiz.TimeLimit !== null) {
  <p class="time-limit">Time limit: {{ quiz.TimeLimit | numeral: 'minute' }}</p>
  }
</div>
<div class="modal-footer">
  <div class="buttons-box">
    <button class="fto-legacy-btn btn btn-default" type="button" (click)="cancel()">Cancel</button>
    <button class="fto-legacy-btn btn btn-primary" type="button" (click)="proceed()">Start Quiz</button>
  </div>
</div>
